import { TbClipboardCheck } from "react-icons/tb"; 
import React, { useRef } from 'react';
import GxForm from '../../gx/GxForm';
import { useTranslation } from '../../hx/useTranslation';
//import { useNav } from '../../hx/useNav';
import CxHidden from '../../cx/CxHidden';
import CxInput from '../../cx/CxInput';
import CxCombo from '../../cx/CxCombo';
import * as FxLog from '../../fx/FxLog';
import '../../../styles/main.css';
import { StoreSettSms } from "../../gx/GxStore";
import { useSessionStorage } from '../../hx/useSessionStorage';
import * as FxFetch from '../../fx/FxFetch';
import CxDialog from '../../cx/CxDialog';
import CxSnackbar from '../../cx/CxSnackbar';
import CxIconButton from '../../cx/CxIconButton';
import CxIconButtonNew from '../../cx/CxIconButtonNew';
import CxState from '../../cx/CxState';
import { getStoreValue } from "../../gx/GxStore";


const MxSettCommSmsForm = (props) => {
  const [{ trans }] = useTranslation();
  //const [{ navBack }] = useNav();

  let r_form = React.useRef(null);
  const r_snack_error = React.useRef(null);

  const [, updateState] = React.useState();
  const forceUIUpdate = React.useCallback(() => updateState({}), []);
  
  const r_cxdialog = React.useRef(null);

  const rf_test_txMobile = React.useRef('');

  const r_snack_test_result = React.useRef(null);
  const r_snack_credits_result = React.useRef(null);

  const [storeSettSms, setStoreSettSms] = useSessionStorage('StoreSettSms', StoreSettSms);
  const [dlgTest, setDlgTest] = React.useState(false);

  React.useEffect(() => {
    if (dlgTest) {
      const savedMobile = localStorage.getItem('MxSettCommSmsForm.txMobileTest');
      const timer = setTimeout(() => {
        if (savedMobile && typeof rf_test_txMobile.current?.setVal === 'function') {
          rf_test_txMobile.current.setVal(savedMobile);
        }
      }, 150);
      return () => clearTimeout(timer);
    }
  }, [dlgTest]);

  const rf_itSms = React.useRef(null);
  const rf_txName = React.useRef(null);
  const rf_txFrom = React.useRef(null);
  const rf_txCode = React.useRef(null);
  const rf_txSmsProvider = React.useRef(null);


  const formLoad = async (data) => {
    if (data === null) { //nuevo registro
      let txLang = getStoreValue('StoreSession', 'txLocale').substring(0,2);
      FxLog.infox('MxSettCommSmsForm.formLoad', '...txLang', txLang);
      switch (txLang) {
        case 'en':
          rf_txName.current.setVal('My SMS account');
          rf_txFrom.current.setVal('My Business');
          rf_txCode.current.setVal('1'); //US
          break;
  
        case 'es':
          rf_txName.current.setVal('Mi cuenta SMS');
          rf_txFrom.current.setVal('Mi Negocio');
          rf_txCode.current.setVal('34'); //Spain
          break;
  
        default:
          break;
      }
    }
  }
  const formSave = async (lastSaveRv) => {
    if (lastSaveRv.theStatus === 'error') {
      if (lastSaveRv.theValue==='rv_name_exists') r_snack_error.current.setValAndOpen(trans('msg.existing_x','field.name'));
      if (lastSaveRv.theValue==='rv_default_needed') r_snack_error.current.setValAndOpen(trans('msg.default_x_required','field.account'));
    } else {
      storeSettSms.itSms = lastSaveRv.theValue;
      Promise.all([setStoreSettSms(storeSettSms)]).then((result) => {
        //navBack();
        forceUIUpdate();
      });
    }
  }
  const formDelete = async (rv) => {
  }

  const doTest = () => {
    try {
      setDlgTest(false);
      let txMobile = rf_test_txMobile.current.getVal();
      if (txMobile) {
        localStorage.setItem('MxSettCommSmsForm.txMobileTest', txMobile);
        let record = {};
        record['itSms'] = storeSettSms.itSms;
        record['txMobile'] = txMobile;
        Promise.all([FxFetch.doJsonX(`sett/sms/test`, record)]).then((result) => {
          if (result[0].theValue === 'OK') {
            r_snack_test_result.current.setVal(result[0].theValue);
          } else {
            switch (result[0].theValue) {
              case 'rv_debugging':
                r_snack_test_result.current.setVal(`${trans('msg.operation_failed')}: DEBUGGING`);
                break;
              case 'rv_insufficient_credit':
                r_snack_test_result.current.setVal(trans('msg.insufficient_credit'));
                break;
              default:
                r_snack_test_result.current.setVal(trans('msg.operation_failed'));
                break;
            }
          }
          r_snack_test_result.current.setOpen(true);
        });
      } else {
        localStorage.removeItem('MxSettCommSmsForm.txMobileTest');
      }

    } catch (error) {
      FxLog.errorx("MxSettCommSmsForm.doTest", error);
    }
  };

  const doCheckCredits = () => {
    try {
      if (storeSettSms.itSms) {
        let record = {};
        record['itSms'] = storeSettSms.itSms;
        Promise.all([FxFetch.doJsonX(`sett/sms/get_credits`, record)]).then((result) => {
          if (result[0].theValue.startsWith("rv_")) {
            r_snack_credits_result.current.setVal(trans('msg.error'));
          } else {
            r_snack_credits_result.current.setVal(trans('field.availability') + ': ' + result[0].theValue);
          }
          r_snack_credits_result.current.setOpen(true);
        });
      }

    } catch (error) {
      FxLog.errorx("MxSettCommSmsForm.doCheckCredits", error);
    }
  };

  return (
    <div>
      <GxForm
        moduleName={`${trans('field.comms')}: ${trans('field.sms')}`}
        xref={r_form}
        url="sett/sms"
        filterIdField='itSms'
        filterIdValue={storeSettSms.itSms || null}
        onFormLoad={formLoad}
        onFormSave={formSave}
        onFormDelete={formDelete}
        addToolbarButtons={
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            {storeSettSms.itSms && <CxIconButtonNew icon={<TbClipboardCheck fontSize="24px" style={{paddingTop:'0px'}} />} classType="ibs_iconbutton_toolbar" onClick={() => setDlgTest(true)} tooltip={trans('field.test')} />}
            {storeSettSms.itSms && <CxIconButton type="info" classType="ibs_iconbutton_toolbar" onClick={() => doCheckCredits()} tooltip={trans('field.credits')} />}
          </div>
        }
      >
        <CxHidden xref={rf_itSms} dbfield="t_sms.itSms" value={storeSettSms.itSms || ''} />
        <CxInput xref={rf_txName} label={trans('field.name')} dbfield="t_sms.txName" required maxLength={50} />
        <CxCombo
          xref={rf_txSmsProvider}
          label={trans('field.provider')}
          dbfield="t_sms.txSmsProvider"
          list={[
            { id: 'T', type: `${trans('field.provider')} 1` },
            { id: 'L', type: `${trans('field.provider')} 2` },
          ]}
          defaultValue="T"
          clearDisabled
          required
        />
        <CxInput xref={rf_txFrom} label={trans('field.sender')} dbfield="t_sms.txFrom" maxLength={20} />
        <CxInput xref={rf_txCode} label={trans('field.country_code')} dbfield="t_sms.txCode" maxLength={5} />
        <CxInput xref={useRef(null)} label={trans('field.user')} dbfield="t_sms.txUser" maxLength={50} />
        <CxInput xref={useRef(null)} type="password" label={trans('field.password')} dbfield="t_sms.txPass" maxLength={50} />

        <span style={{ width: '100%', textAlign: 'left', display: 'flex', flexDirection: 'row', flexFlow: 'row wrap', gap: '5px' }}> {/* línea separada */}
          <CxState mode='checkbox' xref={useRef(null)} label={trans('field.default_0')} dbfield="t_sms.boDefault" />
        </span>

      </GxForm>

      <CxDialog
        xref={r_cxdialog}
        title={`${trans('field.addressee')} (${trans('field.mobile')})`}
        open={dlgTest}
        onOk={doTest}
        onCancel={() => setDlgTest(false)}
        height='200px'>

        <CxInput xref={rf_test_txMobile} width="var(--ibs_control_width_md)" />
      </CxDialog>

      <CxSnackbar xref={r_snack_test_result} severity="warning" />
      <CxSnackbar xref={r_snack_credits_result} severity="info" />
      <CxSnackbar xref={r_snack_error} severity="error" />

    </div>
  );

}

export default MxSettCommSmsForm;
